export default __webpack_public_path__ + "media/images/mastodon-ui-13fe83dbedb464a2560c953ab5fc9f2f.png";